import React from 'react';
import { Link } from 'react-router-dom';
import library from "../../assets/image/library.png";

const Library = () => {
    return (
        <div className='max-w-md  items-center mx-auto'>
            <div>
                <p className='text-center font-bold text-2xl text-secondary mb-2'>পূর্ব বড়ুয়া তরুণ সংঘ পাঠাগার</p>
                <img width={200} height={200} className="float-left px-2" src={library} alt="" />
                <p>‘পড়িলে বই আলোকিত হই, না পড়িলে বই অন্ধকারে রই।’
                    সামাজিক প্রতিষ্ঠান হিসেবে এবং সামাজিক প্রয়োজনে পাঠাগারের অবদান অপরিসীম। আমাদের সমাজব্যবস্থায় এর ভূমিকা অত্যন্ত গুরুত্বপূর্ণ। আমরা বর্তমানে যেভাবে প্রাতিষ্ঠানিক শিক্ষা লাভ করছি প্রকৃত বিবেচনায় এটা শিক্ষার একটা খণ্ডিত অংশ মাত্র। মেধার যথার্থ বিকাশে আনুষ্ঠানিক শিক্ষাকে আগে প্রসারিত এবং সামাজিকভাবে প্রতিষ্ঠিত করে পাঠাগার। পাঠাগার সমাজের সর্বস্তরের মানুষের অবাধ যাতায়াতের মাধ্যমে জ্ঞানের আলো উন্মোচিত করতে গুরুত্বপূর্ণ ভূমিকা পালন করে। পাঠাগার আলোকিত করে তোলে মানুষকে। পাঠাগার মানুষকে তার আত্মিক অন্বেষণের পথ নির্দেশ করে যা ক্ষুধা-তৃষ্ণা; শ্বাস-প্রশ্বাসের মতোই একান্ত জরুরি। আমাদের সমাজকে শিক্ষিত করে তুলতে হলে, আমাদের চাই আলোকিত মানুষ। আর আলোকিত মানুষ পেতে চাই পাঠাগার। পাঠাগার মানুষের জ্ঞানের সব দুয়ার উন্মোচন করে মানবাত্মা করে তোলে প্রজ্বলিত। পাঠাগার আমাদের চারপাশের রহস্যময় বিশ্বের দুয়ার খুলে দেয়। সমাজের মস্তিষ্ক ও জ্ঞানধার হলো পাঠাগার। তাই দীপ্ত, মেধা ও নৈতিকতার সমন্বয়ে সুশীল সমাজ পাওয়ার লক্ষ্যে সমাজের প্রতিটি স্তরে পৌঁছে দিতে হবে এই স্লোগান—‘পড়িলে বই আলোকিত হই, না পড়িলে বই অন্ধকারে রই।’
                </p>
                <div className='flex justify-center my-10'>
                    <Link to="/donation" className='btn btn-primary text-white w-44'>দান করুন</Link>
                </div>
                <p className='text-center font-bold text-xl mb-2'>পাঠাগারের সর্বশেষ কার্যক্রম সমূহ:</p>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 place-content-center place-items-center gap-10'>
                    <img className='h-44 w-52 m-2' src={library} alt="" />
                    <img className='h-44 w-52 m-2' src={library} alt="" />
                    <img className='h-44 w-52 m-2' src={library} alt="" />
                </div>
            </div>
        </div>
    );
};

export default Library;